import { render, staticRenderFns } from "./TextareaGroup.vue?vue&type=template&id=10a94f86&"
import script from "./TextareaGroup.vue?vue&type=script&lang=ts&"
export * from "./TextareaGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports